import { NOTION_ID } from 'product-management/notionId'
import { z } from 'zod'

const PRODUCT_MANAGEMENT_TAB_VALUES = ['map', 'kanban'] as const
export type ProductManagementTabValue = (typeof PRODUCT_MANAGEMENT_TAB_VALUES)[number]

/**
 * Onglet actif et ticket ouvert dans le Kanban, portés par l'URL : ils survivent au rafraîchissement
 * et au partage de lien. Le lien des relances par SMS ouvre ainsi un ticket (NH-48) :
 * `?tab=kanban&ticket=<id>`.
 */
export const productManagementSearchSchema = z.object({
  tab: z.enum(PRODUCT_MANAGEMENT_TAB_VALUES).catch('map'),
  // Identifiant d'une page Notion au format qu'accepte le service : rien d'autre n'atteint le
  // chemin de `GET /map/tickets/:id` (un `..%2F` forgé partirait vers une autre route du service).
  ticket: z.string().regex(NOTION_ID).optional().catch(undefined),
})

type ProductManagementSearch = z.infer<typeof productManagementSearchSchema>

/** Changer d'onglet ferme le ticket ouvert : il n'appartient qu'au Kanban. */
export const withTab = <Search extends ProductManagementSearch>(
  search: Search,
  tab: ProductManagementTabValue,
): Search => ({ ...search, tab, ticket: undefined })

/** Ouvre un ticket du Kanban, ou le ferme (`undefined`). */
export const withOpenTicket = <Search extends ProductManagementSearch>(
  search: Search,
  ticket: string | undefined,
): Search => ({ ...search, ticket })
